import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const SECTIONS = [
  {
    h: "1. Information We Collect",
    body: [
      "We collect information from clients and potential clients when you:",
      "• Submit an inquiry about our services",
      "• Purchase one of our marketing campaigns",
      "The types of information we may collect include:",
      "• Personal Information: Name, business name, email address, mailing address, phone number, and payment details (such as credit card information).",
      "• Technical Information: IP addresses, cookie identifiers, and website activity.",
      "• Anonymous Visits: You may visit our site anonymously.",
      "Cookies and Retargeting: We may collect website activity data, IP addresses, and cookie identifiers to:",
      "• Retarget our ads to better show relevant Company services across platforms (e.g., display networks, social media, search engines).",
      "• Improve the relevance and effectiveness of our advertising campaigns.",
      "This information may be shared with third-party partners, including AdRoll, Facebook, Instagram, Google, and others for advertising purposes.",
      "Opt-Out Options: You can opt out of our retargeting campaigns and data collection at any of the following links:",
      "• DAA: https://optout.aboutads.info",
      "• NAI: https://optout.networkadvertising.org",
      "• EDAA (Europe Only): https://youronlinechoices.eu",
      "Or email us at brettweller34@gmail.com to request data deletion.",
      "We will never sell your personal information.",
    ],
  },
  {
    h: "2. How We Use Your Information",
    body: [
      "We use the information we collect for the following purposes:",
      "• Personalized Experience: To better respond to your individual needs and improve your experience during inquiries or active campaigns.",
      "• Improved Customer Service: To provide customized support and accurately identify and manage your account.",
      "Processing Transactions:",
      "• To process agreed-upon transactions for our marketing services",
      "• You will receive an email receipt confirming your transaction",
      "Email Communications:",
      "• To provide updates, notifications, and important information regarding your campaigns",
      "• To send occasional company news, updates, and educational resources",
      "Opt-Out of Emails: You can unsubscribe from emails at any time using the unsubscribe link or by contacting us at brettweller34@gmail.com.",
    ],
  },
  {
    h: "3. How We Share Your Information",
    body: [
      "We do not sell, trade, or rent your personal information. However, we may share it with trusted third parties to:",
      "• Provide technical, advertising, or operational support",
      "• Fulfill legal requirements, such as responding to valid legal requests",
      "• Support retargeting efforts with partners like AdRoll, Google, Facebook, Instagram, etc.",
      "All third-party partners are required to maintain confidentiality and only use the data for agreed purposes.",
    ],
  },
  {
    h: "4. Cookies and Tracking Technologies",
    body: [
      "We use cookies and similar technologies to:",
      "• Enhance your browsing experience",
      "• Analyze site traffic and trends",
      "• Deliver tailored advertisements across platforms",
      "You may disable cookies in your browser settings; however, doing so may limit some website functionalities.",
    ],
  },
  {
    h: "5. Data Security",
    body: [
      "We implement robust security measures to protect your personal information against unauthorized access, alteration, or disclosure. However, no online transmission is 100% secure, so we cannot guarantee absolute security.",
    ],
  },
  {
    h: "6. Your Rights",
    body: [
      "Depending on your jurisdiction, you have the right to:",
      "• Access: Request the information we hold about you.",
      "• Correct: Update inaccurate or incomplete information.",
      "• Delete: Request the deletion of your data.",
      "• Opt-Out: Withdraw from communications or data usage at any time.",
      "To exercise these rights, email us at brettweller34@gmail.com.",
    ],
  },
  {
    h: "7. Changes to This Privacy Policy",
    body: [
      "We may update this Privacy Policy periodically. Any changes will be posted on this page with an updated Effective Date. We encourage you to review this policy regularly.",
    ],
  },
  {
    h: "8. Contact Us",
    body: [
      "If you have questions or concerns regarding this Privacy Policy, please contact us at brettweller34@gmail.com.",
    ],
  },
];

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-28">
        <section className="border-b border-neutral-200 bg-[#FAFAFA]">
          <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20">
            <p className="overline text-kw-red mb-4">Legal</p>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-kw-ink leading-[1.02]">
              Privacy Policy
            </h1>
          </div>
        </section>

        <article data-testid="privacy-content" className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20">
          <p className="text-neutral-700 leading-relaxed">
            Brett Weller - Keller Williams DTC (“Company,” “we,” “our,” or “us”) is committed to
            protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard
            your personal information when you visit our website or engage with our services.
          </p>

          <div className="mt-12 space-y-10">
            {SECTIONS.map((s) => (
              <div key={s.h}>
                <h2 className="font-serif text-2xl sm:text-3xl tracking-tight text-kw-ink mb-4">{s.h}</h2>
                <div className="space-y-3">
                  {s.body.map((line, i) => (
                    <p
                      key={i}
                      className={`leading-relaxed ${line.startsWith("•") ? "pl-5 text-neutral-600" : "text-neutral-700"}`}
                    >
                      {line}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}
